export const SUBSCRIPTIONS_PUBLIC_GET_FRESH_PRICING_INFO_METHOD = "GET";
export const SUBSCRIPTIONS_PUBLIC_GET_FRESH_PRICING_INFO_PATH = "/fresh/pricing";
